import React from "react";

export type AdminDataTableShellProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Enveloppe tableau (coins, bordure, fond) pour pages métier admin.
 */
export function AdminDataTableShell({
  children,
  className = "",
}: AdminDataTableShellProps): React.JSX.Element {
  return (
    <div
      className={`min-w-0 overflow-hidden rounded-2xl border border-slate-800 bg-slate-900/50 shadow-xl ${className}`}
    >
      {/* Défilement horizontal explicite : évite colonnes tableau masquées sur mobile / laptop étroit */}
      <div className="min-w-0 overflow-x-auto">{children}</div>
    </div>
  );
}
